import { render, staticRenderFns } from "./timeline-progreso.vue?vue&type=template&id=54ad20cb"
import script from "./timeline-progreso.vue?vue&type=script&lang=js"
export * from "./timeline-progreso.vue?vue&type=script&lang=js"
import style0 from "./timeline-progreso.vue?vue&type=style&index=0&id=54ad20cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports